// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Grid, Typography, Button, Input } from '@material-ui/core';
import { connect } from 'react-redux';
import { FixedSizeList } from 'react-window';
import { toast } from 'react-toastify';

// Internal Dependencies
import Header from './header';
import apiService from '../../../services.js/apiService';
import Loading from '../../global/Loading';
import { setMall, setStore } from '../../../actions/admin/uploadScrappedPromoAction';
import { IsEmpty } from '../../../common/checks';

class SelectStore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stores:      [],
      displayList: [],
      loading:     false,
    };

    this.mallId = this.props.mall.id;
    console.log('mallId=', this.mallId);

    this.clearMallSelect = this.clearMallSelect.bind(this);
    this.onStoreSelect = this.onStoreSelect.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.displayStoreItem = this.displayStoreItem.bind(this);
  }

  componentDidMount() {
    this.getStores();
  }

  async getStores() {
    try {
      this.setState({ loading: true });

      const stores = _.orderBy(await apiService.getMallOutlets(this.mallId), [(outlet) => outlet.name.toLowerCase()], ['asc']);

      console.log('stores=');
      console.log(stores);
      // stores = stores.concat(stores);
      // stores = stores.concat(stores);
      // stores = stores.concat(stores);
      // stores = stores.concat(stores);
      this.setState({ loading: false, stores, displayList: stores });
    } catch (error) {
      this.setState({ loading: false });
      console.log('error getting stores data');
      console.log(error);
      toast.error(String(error));
    }
  }

  onStoreSelect(store) {
    console.log('Selected store=');
    console.log(store);
    this.props.setStoreDispatcher(store.pageId, store.name, store.id, store.postalCode);
  }

  clearMallSelect() {
    this.props.setMallDispatcher('', '');
  }

  displayStoreItem({ index, style }) {
    return (
      <div style={{
        ...style,
        height: 50,
      }}
      >
        <Button
          className="d-flex col align-items-center"
          style={{
            paddingTop:    15,
            paddingBottom: 15,
          }}
          onClick={() => this.onStoreSelect(this.state.displayList[index])}
        >
          <Typography style={{}} variant="h6">{this.state.displayList[index].name}</Typography>
        </Button>
      </div>
    );
  }

  onFilterChange(evt) {
    console.log('evt=');
    console.log(evt.target.value);
    const keyword = String(evt.target.value);
    const { stores } = this.state;
    if (!IsEmpty(keyword)) {
      const storeFilter = stores.filter((store) => store.name.toLowerCase().includes(keyword.toLowerCase()));
      this.setState({ displayList: storeFilter });
    } else {
      this.setState({ displayList: stores });
    }
  }

  render() {
    return (
      <Grid container direction="column">
        <Header
          title="(Step 2/3) Select Store"
          showBackButton
          onBackPress={this.clearMallSelect}
        />
        <Grid item container xs={12} className="mt-4">
          <Input
            type="text"
            fullWidth
            placeholder="Filter"
            onChange={this.onFilterChange}
            inputProps={{
              style: {
                fontSize: 25,
              },
            }}
          />
        </Grid>
        <Grid container item xs={12} style={{}}>
          {
            !IsEmpty(this.state.displayList) && (
              <FixedSizeList
                height={400}
                width="100%"
                itemSize={65}
                itemCount={this.state.displayList.length}
                style={{
                  top:         0,
                  borderColor: 'black',
                  borderWidth: 1,
                  borderStyle: 'solid',
                }}
              >
                {this.displayStoreItem}
              </FixedSizeList>
            )
          }
        </Grid>
        { this.state.loading && <Loading backgroundColor="transparent" />}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  mall: state.admin.uploadScrappedPromo.mall,
});

const mapDispatchToProps = (dispatch) => ({
  setMallDispatcher:  (id, name) => dispatch(setMall(id, name)),
  setStoreDispatcher: (id, name, outletId, postalCode) => dispatch(setStore(id, name, outletId, postalCode)),
});

SelectStore.propTypes = {
  mall: PropTypes.shape({
    id:   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,

  setMallDispatcher:  PropTypes.func.isRequired,
  setStoreDispatcher: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectStore);
